import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';

// Public pages
import HomePage from './pages/HomePage';
import WatchMarketplacePage from './pages/marketplace/WatchMarketplacePage';
import ListingDetailsPage from './pages/marketplace/ListingDetailsPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import CookiePolicyPage from './pages/legal/CookiePolicyPage';
import TermsPage from './pages/legal/TermsPage';

// Auth
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';

// Checkout
import CheckoutPage from './pages/checkout/CheckoutPage';
import CheckoutSuccessPage from './pages/checkout/CheckoutSuccessPage';

// User
import MyOrdersPage from './pages/orders/MyOrdersPage';

// Admin
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import AdminDiscountsPage from './pages/admin/AdminDiscountsPage';
import AdminMessagesPage from './pages/admin/AdminMessagesPage';
import AdminListingsPage from './pages/admin/AdminListingsPage';
import AdminProposalsPage from './pages/admin/AdminProposalsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="mercato" element={<WatchMarketplacePage />} />
            <Route path="mercato/:id" element={<ListingDetailsPage />} />
            <Route path="contatti" element={<ContactPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="cookie-policy" element={<CookiePolicyPage />} />
            <Route path="termini-e-condizioni" element={<TermsPage />} />

            {/* Auth */}
            <Route path="accedi" element={<LoginPage />} />
            <Route path="registrati" element={<RegisterPage />} />

            {/* Checkout */}
            <Route path="checkout/:id" element={<CheckoutPage />} />
            <Route path="checkout/success" element={<CheckoutSuccessPage />} />

            {/* User */}
            <Route path="i-miei-ordini" element={<MyOrdersPage />} />

            {/* Admin */}
            <Route path="admin" element={<AdminDashboardPage />} />
            <Route path="admin/ordini" element={<AdminOrdersPage />} />
            <Route path="admin/sconti" element={<AdminDiscountsPage />} />
            <Route path="admin/messaggi" element={<AdminMessagesPage />} />
            <Route path="admin/prezzi" element={<AdminListingsPage />} />
            <Route path="admin/proposte" element={<AdminProposalsPage />} />
            <Route path="admin/utenti" element={<AdminUsersPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
